import { Injectable, OnDestroy, inject } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { BackendResponse, StorageV2Service, StoreV2 } from '@schenck/rotec-components';
import { Modules, SoftwareVersion } from '../utils/models/software.model';
import { SoftwareApi } from '../api/software.api';

@Injectable()
export class SoftwareService extends StoreV2<Modules> implements OnDestroy {
  private readonly softwareApi = inject(SoftwareApi);
  private readonly loaded$ = new ReplaySubject(1);
  private readonly onDestroy$ = new Subject<void>();

  public modules$: Observable<Modules> = this.loaded$.pipe(
    switchMap(() => this.state$),
    map((modules) => modules)
  );

  constructor() {
    const storageService = inject(StorageV2Service);

    super(
      {
        modules: [],
      },
      'SoftwareService',
      { storageService, name: 'SoftwareService' }
    );

    this.loadSoftwareModules$();
  }

  public loadSoftwareModules$(): void {
    this.softwareApi
      .getSoftwareModules$()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((response) => {
        if (BackendResponse.isSuccess(response)) {
          this.setState('got all modules', response.result);
          this.loaded$.next(null);
        } else {
          throw response.error;
        }
      });
  }

  public getSoftwareVersions$(): Observable<SoftwareVersion[]> {
    return this.softwareApi.getSoftwareVersions$();
  }

  public getSoftwareLicenses$(): Observable<string[]> {
    return this.softwareApi.getSoftwareLicenses$();
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
